"use client"

import type { ButtonHTMLAttributes, ComponentProps, FunctionComponent, MouseEventHandler } from "react"

import { useRouter } from "next/navigation"

import { TrackButton } from "@/modules/tracking/components/TrackButton"

type TrackObfuscatedLinkProps = ButtonHTMLAttributes<HTMLButtonElement> &
  ComponentProps<typeof TrackButton<"button">> & {
    href: string
  }

export const TrackObfuscatedLink: FunctionComponent<TrackObfuscatedLinkProps> = ({ href, onClick, ...props }) => {
  const { push } = useRouter()

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event): void => {
    push(href)

    if (typeof onClick !== "undefined") {
      onClick?.(event)
    }
  }

  return <TrackButton {...props} onClick={handleClick} />
}
